<script>
export default {
  name: 'MemberPageHeading',
  props: {
    eyebrow: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <header class="member-heading">
    <div class="member-heading__eyebrow">{{ eyebrow }}</div>
    <h1 class="member-heading__title">{{ title }}</h1>
    <p class="member-heading__subtitle">{{ subtitle }}</p>
  </header>
</template>

<style scoped>
.member-heading {
  margin-bottom: 20px;
}

.member-heading__eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6ca4ff;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: .15em;
  text-transform: uppercase;
}

.member-heading__eyebrow::before {
  width: 18px;
  height: 1px;
  background: currentColor;
  content: '';
}

.member-heading__title {
  margin: 8px 0 4px;
  color: #f7faff;
  font-family: 'Kanit', sans-serif;
  font-size: clamp(26px, 5vw, 34px);
  font-weight: 600;
  letter-spacing: -.02em;
  line-height: 1.15;
}

.member-heading__subtitle {
  margin: 0;
  color: #8793aa;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.6;
}
</style>
